import NumberFlow, { continuous } from '@number-flow/react';
import { useAnimatedValue } from './useAnimatedValue';

interface AnimatedNumberProps {
    value: number;
    suffix?: string;
    willChange?: boolean;
}

export function AnimatedNumber({
    value,
    suffix = '',
    willChange = false,
}: AnimatedNumberProps) {
    const { displayValue, animated } = useAnimatedValue(value);

    return (
        <NumberFlow
            value={displayValue}
            animated={animated}
            locales="en-US"
            plugins={[continuous]}
            suffix={suffix}
            willChange={willChange}
        />
    );
}
